module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadConfig.status) ? _c('div', {
    staticClass: "globalLoad",
    style: ({
      'background-color': _vm.loadConfig.BgColor ? _vm.loadConfig.BgColor : ''
    })
  }, [_c('div', {
    staticClass: "globalLoad-wrapper"
  }, [_c('div', {
    staticClass: "globalLoad-content"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgs('loading1.gif')
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('share.loading.' + _vm.loadConfig.title)))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82527f3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/globalLoad.vue
// module id = 556
// module chunks = 62